import React, { useState } from "react";
import { FiX, FiList, FiPlus, FiTrash2 } from "react-icons/fi";

const ListMessageModal = ({ show, handleClose, onSave }) => {
  const [formData, setFormData] = useState({
    triggerType: "",
    button: "",
    header: "Please select an option:",
    items: [
      { id: 1, title: "", description: "" },
      { id: 2, title: "", description: "" }
    ]
  });

  const triggerOptions = [
    { value: "button_click", label: "Button Click" },
    { value: "keyword", label: "Keyword Match" }
  ];

  const buttonOptions = [
    { value: "help", label: "Help Button" },
    { value: "options", label: "Options Button" },
    { value: "menu", label: "Menu Button" }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleItemChange = (id, field, value) => {
    setFormData(prev => ({
      ...prev,
      items: prev.items.map(item => 
        item.id === id ? { ...item, [field]: value } : item
      )
    }));
  };

  const addItem = () => {
    setFormData(prev => ({
      ...prev,
      items: [...prev.items, { 
        id: prev.items.length + 1, 
        title: "", 
        description: "" 
      }]
    }));
  };

  const removeItem = (id) => {
    if (formData.items.length > 1) {
      setFormData(prev => ({
        ...prev,
        items: prev.items.filter(item => item.id !== id)
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    handleClose();
  };

  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content border-0 shadow" style={{overflowY:'auto'}}>
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">
              <FiList className="me-2" />
              Interactive List Configuration
            </h5>
            <button type="button" className="btn-close btn-close-white" onClick={handleClose}>
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="alert alert-info">
                <small>
                  When triggered, this will send an interactive list message. Each option can trigger different responses.
                </small>
              </div>

              <div className="mb-4">
                <label className="form-label fw-bold d-block mb-2">Trigger Condition</label>
                <select 
                  name="triggerType"
                  value={formData.triggerType}
                  onChange={handleChange}
                  className="form-select form-select-lg"
                  required
                >
                  <option value="">Select trigger condition</option>
                  {triggerOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>

              {formData.triggerType === "button_click" && (
                <div className="mb-4">
                  <label className="form-label fw-bold d-block mb-2">Select Button</label>
                  <select 
                    name="button"
                    value={formData.button}
                    onChange={handleChange}
                    className="form-select form-select-lg"
                    required
                  >
                    <option value="">Select button</option>
                    {buttonOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              )}

              {formData.triggerType === "keyword" && (
                <div className="mb-4">
                  <label className="form-label fw-bold d-block mb-2">Keywords (comma separated)</label>
                  <input
                    type="text"
                    name="keywords"
                    value={formData.keywords || ""}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="help, options, menu"
                    required
                  />
                </div>
              )}

              <div className="mb-4">
                <label className="form-label fw-bold d-block mb-2">List Header</label>
                <input
                  type="text"
                  name="header"
                  value={formData.header}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold d-block mb-2">List Items</label>
                {formData.items.map((item) => (
                  <div key={item.id} className="card mb-3">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="mb-0">Item {item.id}</h6>
                        {formData.items.length > 1 && (
                          <button 
                            type="button" 
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => removeItem(item.id)}
                          >
                            <FiTrash2 />
                          </button>
                        )}
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Title</label>
                        <input
                          type="text"
                          value={item.title}
                          onChange={(e) => handleItemChange(item.id, 'title', e.target.value)}
                          className="form-control"
                          required
                        />
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Description</label>
                        <input
                          type="text"
                          value={item.description}
                          onChange={(e) => handleItemChange(item.id, 'description', e.target.value)}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
                ))}

                <button 
                  type="button" 
                  className="btn btn-outline-primary btn-sm"
                  onClick={addItem}
                  disabled={formData.items.length >= 10}
                >
                  <FiPlus className="me-1" />
                  Add Item {formData.items.length < 10 ? `(${formData.items.length}/10)` : '(Max reached)'}
                </button>
              </div>
            </div>

            <div className="modal-footer border-top-0">
              <button type="button" className="btn btn-outline-secondary" onClick={handleClose}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save Configuration
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ListMessageModal;